module.exports = __webpack_public_path__ + "static/media/DSC00003.21ec18db.jpg";